export const baseUrl = 'https://www.sravni.ru';
